import { computed } from 'vue';
import { MONET_URL } from '@/static/urls';
import { DashboardAccessItem } from '@/models/dashboard-data.interface';
import { LoadingState } from '@/models/loading.interface';
import { ModalDashboardPreviewState } from '@/models/modal.interface';
import DataTracker from '@/infrastructure/data-tracker';
import store from '@/store';

export default class InactiveDashboardsOverviewCode {

	public isLoading = computed((): boolean => {
		const loadingState = store.getters.loadingStateDashboards();
		return loadingState === LoadingState.ACTIVE;
	})

	public inactiveDashboards = computed((): DashboardAccessItem[] => {
		return store.getters.inactiveDashboards();
	});

	private tracker = computed((): DataTracker => {
		return store.getters.tracker();
	});

	public retrieveDescriptionParagraphsForDashboard(dashboard: DashboardAccessItem): string[] {
		return dashboard.descriptionShort || [];
	}

	public retrieveIconUrlForDashboard(dashboard: DashboardAccessItem): string {
		return `${MONET_URL}module_${dashboard.tag}.png`;
	}

	public retrievePreviewUrlForDashboard(dashboard: DashboardAccessItem): string {
		return `${MONET_URL}preview_${dashboard.tag}.png`;
	}

	public openDashboardPreview(id: string): void {
		this.tracker.value.trackDashboardClick(id, false);
		store.mutations.setRoutePropId(id);
		store.mutations.setModalDashboardPreviewState(ModalDashboardPreviewState.OVERVIEW);
	}
}
